module.exports = __webpack_public_path__ + "static/media/capa-contato-mobile.513e4210.png";